module.exports = __webpack_public_path__ + "img/mountains painted red.14ad4926.png";